module.exports = __webpack_public_path__ + "assets/img/driver-btn-ca342794.png";